// extracted by mini-css-extract-plugin
export default {"snackContainer":"SnackBar_snackContainer__ZgYIl","successMessage":"SnackBar_successMessage__kDRVz"};